import { render } from "./UpdateEventModal.vue?vue&type=template&id=231af055&scoped=true"
import script from "./UpdateEventModal.vue?vue&type=script&lang=js"
export * from "./UpdateEventModal.vue?vue&type=script&lang=js"

import "./UpdateEventModal.vue?vue&type=style&index=0&id=231af055&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231af055"]])

export default __exports__